import axios from 'axios'

export default {
  export: async (sitePath, id) => {
    const url = `${sitePath}/exportimport/export_site/`;

    const response = await axios.get(url);

    return response.data
  },

  import: async (sitePath, formdata) => {
    const url = `${sitePath}/exportimport/import_site/`;

    const response = await axios.post(url,formdata);

    return response.data;
  },
}
